import {withComponent} from '../../hoc/withComponent';
import {DialogTitleBase} from './DialogTitleBase';

/** @component */
export const withDialogTitle = withComponent(DialogTitleBase);
